import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

@NgModule({
  imports: [HttpClientModule]
})
export class HttpModule {
  static forRoot(httpConfigProvider: Provider): ModuleWithProviders<HttpModule> {
    return {
      ngModule: HttpModule,
      providers: [httpConfigProvider]
    };
  }
}
